import { checkIsLanding, getPictureOrigById } from "~/utils";
import { useSelector } from "react-redux";
import { isGoogleVisit } from "~/utils/botDetection";
import { wrapper } from "../../redux";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import { fetchRightNews } from "/redux/action-creaters/content";
import Redis from "/lib/redis";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { Api } from "../../api";
import { sspWrapper } from "../../utils/errors/sspWrapper";
import ServicesNewItems from "../../components/pages/services/items";
import Breadcrumbs from "../../components/common/breadcrumbs";
import ServicesNewEmpty from "../../components/pages/services/empty";
import { getHost } from "../../utils/locationServer";

function normalizeServiceRows(contentRows) {
  const rows = Array.isArray(contentRows) ? contentRows : [];
  return rows
    .filter((row) => row && row.active !== false)
    .map((row) => ({
      id: row.id,
      sort: Number(row.sort || 0),
      name: row.listName || row.name,
      description: row.data.listDescription || "",
      code: row.code,
      image:
        getPictureOrigById(row.data.listImage, "services") || "/no-photo.png",
      domains: row.data.domains,
    }))
    .sort((a, b) => a.sort - b.sort);
}

export default function ServicesNewPage({
  services,
  scripts,
  host,
  isGoogle,
  city,
  availableCities,
}) {
  const hasServices = Array.isArray(services) && services.length > 0;
  const citySlug = typeof city === "string" ? city : "";
  const subPage = citySlug ? `/${citySlug}` : "";
  const { domainData } = useSelector((state) => state.contacts);

  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <div className="container">
        <Breadcrumbs />

        {!hasServices && (
          <ServicesNewEmpty
            availableCities={availableCities}
            mode={isGoogle ? "relative" : "absolute"}
            variant={isGoogle ? "google" : "default"}
            isLanding={checkIsLanding(host)}
          />
        )}

        {hasServices && (
          <>
            <h1>Наши услуги в {domainData.declension}</h1>
            <ServicesNewItems services={services} subPage={subPage} />
          </>
        )}
      </div>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ query, req }) => {
    const isGoogle = isGoogleVisit({
      userAgent: req.headers["user-agent"],
      referer: req.headers.referer,
      cookieValue: req.cookies?.isGoogle,
      queryValue: query?.isGoogle,
    });

    const reset = Boolean(query?.reset);

    const citySlug =
      typeof query?.city === "string" && query.city.length > 0
        ? query.city
        : null;
    const isCityPath = Boolean(citySlug);

    if (isCityPath && !isGoogle) {
      return {
        redirect: {
          destination: "/services/",
          statusCode: 301,
        },
      };
    }

    if (isCityPath) {
      req.headers.host = `${citySlug}.farkop.ru`;
    }

    const apiHost = getHost(req);

    const allServiceRows = await Api.databaseContent.getAllByType(
      Redis,
      reset,
      "content-pages-services",
    );

    const allServices = normalizeServiceRows(allServiceRows);
    const services = allServices.filter(
      (service) => service.domains === apiHost,
    );
    const domains = await Api.databaseContent.getDomains(Redis, reset);
    const allDomains = {};
    allServices.forEach((service) => {
      allDomains[service.domains] = true;
    });
    const availableCities = Object.keys(allDomains)
      .map((domain) => {
        const subDomain = domain.split(".")[0];
        const domainData = domains.find(
          (domainItem) => domainItem.code === subDomain,
        );
        if (domainData) {
          return { code: domainData.code, name: domainData.name };
        }
        return null;
      })
      .filter(Boolean);

    await store.dispatch(await fetchRightNews(Redis, reset));

    store.dispatch(addBreadcrumb({ link: "/services/", name: "Услуги" }));

    const basePath = isCityPath ? `/${citySlug}/services/` : "/services/";

    return pagesWrapper(
      {
        pageType: SITE_PAGE_TYPE.servicesList,
        isGoogle,
        city: isCityPath ? citySlug : null,
        services,
        availableCities,
      },
      store,
      Redis,
      { req, query },
      basePath,
    );
  }),
);
